import { Chip } from '@material-ui/core';

export interface TypeChipProps {
  type?: string | undefined;
}

export const TypeChip: React.FC<TypeChipProps> = ({ type }) => {
  return (
    <Chip
      size="small"
      label={String(type || 'Not specified')}
      color="primary"
      variant="outlined"
    />
  );
};
